import * as React from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, selectUser, Update, useCacheRecord } from 'gossamer-front-end';
import { Institution } from 'cb-model';
import { Task } from 'gossamer-model';
import { getListRowLink } from 'gossamer-unified';

export const InstitutionUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(Institution, params.key);
  const user = useSelector(selectUser);
  const handleExit = () => navigate(getListRowLink(Institution.listRowLink, params.key));
  return (
    <>
      <PageTitle verb="Update" entity={Institution} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/institution-update"
        handleCancel={handleExit}
        handleSuccess={(_resp, resetCache) => {
          resetCache(Task.id);
          handleExit();
        }}
        initialization={{
          main: { type: 'update-single', entity: Institution, record },
        }}
      >
        <Update
          valuesKey="main"
          entity={Institution}
          fieldGroup={user.roleId === 'staff' ? undefined : 'admin-updatable'}
          subtitle="Please include at least a Logo image and a Banner image to ensure your institution is displayed well on the website. Please reach out to info@careerbook.co.uk for advice on using images."
        />
      </FormManager>
    </>
  );
};
